"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogLayoutCentered = void 0;
var React = __importStar(require("react"));
var DialogLayoutBase_1 = require("./DialogLayoutBase");
var icons_1 = require("@epic-ui/icons");
var DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var DialogLayoutCentered = function (_a) {
    var dialogTitle = _a.dialogTitle, _b = _a.DialogTitleProps, _c = _b === void 0 ? { disableTypography: false } : _b, disableTypography = _c.disableTypography, // Intercept prop to replace typography
    DialogTitleProps = __rest(_c, ["disableTypography"]), onClose = _a.onClose, displayClose = _a.displayClose, onClickClose = _a.onClickClose, CloseButtonProps = _a.CloseButtonProps, children = _a.children, DialogContentProps = _a.DialogContentProps, dialogActions = _a.dialogActions, DialogActionsProps = _a.DialogActionsProps, TitleTypographyProps = _a.TitleTypographyProps;
    var hasDialogTitle = Boolean(dialogTitle || displayClose);
    return (React.createElement(React.Fragment, null,
        hasDialogTitle && (React.createElement(DialogLayoutBase_1.DialogTitle, __assign({}, DialogTitleProps),
            React.createElement(DialogLayoutBase_1.DialogTitleBody, null, disableTypography ? (dialogTitle) : (React.createElement(Typography_1.default, __assign({ variant: "h4", component: "h2", color: "textPrimary" }, TitleTypographyProps), dialogTitle))),
            displayClose && (React.createElement(IconButton_1.default, __assign({ size: "small", onClick: onClickClose || (function (e) { return onClose && onClose(e, "backdropClick"); }) }, CloseButtonProps),
                React.createElement(icons_1.Close, null))))),
        children && (React.createElement(DialogContent_1.default, __assign({}, DialogContentProps), children)),
        dialogActions && (React.createElement(DialogActions_1.default, __assign({}, DialogActionsProps), dialogActions))));
};
exports.DialogLayoutCentered = DialogLayoutCentered;
//# sourceMappingURL=DialogLayoutCentered.js.map